"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Spacing = _interopRequireDefault(require("../Spacing"));

/**
 * Content body root of a card.
 *
 * All props will be spread to the root `Spacing` element.
 */
var CardContent = function CardContent(props) {
  return /*#__PURE__*/_react["default"].createElement(_Spacing["default"], (0, _extends2["default"])({
    padding: 2,
    paddingTop: 5,
    paddingBottom: 5
  }, props));
};

CardContent.propTypes = {
  /** The content of the component. */
  children: _propTypes["default"].node.isRequired
};
var _default = CardContent;
exports["default"] = _default;